import React, { useEffect, useCallback } from 'react';
import { X, ChevronLeft, ChevronRight } from 'lucide-react';

const Lightbox = ({ images, currentIndex, onClose, onPrev, onNext }) => {
  const handleKeyDown = useCallback((e) => {
    if (e.key === 'Escape') onClose();
    if (e.key === 'ArrowLeft' && onPrev) onPrev();
    if (e.key === 'ArrowRight' && onNext) onNext();
  }, [onClose, onPrev, onNext]);

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = '';
    };
  }, [handleKeyDown]);

  if (currentIndex === null || currentIndex === undefined) return null;

  const current = images[currentIndex];

  return (
    <div
      data-testid="lightbox-overlay"
      className="fixed inset-0 z-[9999] bg-black/90 flex items-center justify-center"
      onClick={onClose}
    >
      <button
        data-testid="lightbox-close"
        onClick={onClose}
        className="absolute top-4 right-4 text-white/80 hover:text-white z-10 p-2"
      >
        <X size={32} />
      </button>

      {images.length > 1 && currentIndex > 0 && (
        <button
          data-testid="lightbox-prev"
          onClick={(e) => { e.stopPropagation(); onPrev(); }}
          className="absolute left-4 text-white/70 hover:text-white z-10 p-2"
        >
          <ChevronLeft size={40} />
        </button>
      )}

      {images.length > 1 && currentIndex < images.length - 1 && (
        <button
          data-testid="lightbox-next"
          onClick={(e) => { e.stopPropagation(); onNext(); }}
          className="absolute right-4 text-white/70 hover:text-white z-10 p-2"
        >
          <ChevronRight size={40} />
        </button>
      )}

      <div
        className="max-w-[90vw] max-h-[85vh] flex flex-col items-center"
        onClick={(e) => e.stopPropagation()}
      >
        <img
          src={current.src}
          alt={current.alt || ''}
          className="max-w-full max-h-[80vh] object-contain"
        />
        {current.caption && (
          <p className="text-white/90 text-center mt-3 text-sm">{current.caption}</p>
        )}
        <p className="text-white/50 text-xs mt-1">
          {currentIndex + 1} / {images.length}
        </p>
      </div>
    </div>
  );
};

export default Lightbox;
